import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ParticipantField } from '../../models/participant-field.model';
import { SigningValidatorsUtil } from '../../utils/validators.util';

@Component({
  selector: 'portal-signing-participant-field-form-dialog',
  templateUrl: './participant-field-form-dialog.component.html',
  styleUrls: ['./participant-field-form-dialog.component.scss'],
})
export class ParticipantFieldFormDialogComponent {
  property: ParticipantField;
  form: FormGroup;
  constructor(
    private dialogRef: MatDialogRef<ParticipantFieldFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private modalData: { property: ParticipantField; value: string },
    private formBuilder: FormBuilder,
  ) {
    this.property = this.modalData.property;
    this.form = this.createForm(this.modalData.property, this.modalData.value);
  }

  createForm(property: ParticipantField, value: string): FormGroup {
    const formGroup: any = {};
    const control =
      property && property.required
        ? new FormControl(value, {
            validators: SigningValidatorsUtil.generateValidators(property.type),
            // updateOn: 'blur'
          })
        : new FormControl(value);
    formGroup[property.key] = control;
    return new FormGroup(formGroup);
  }
  close(): void {
    this.dialogRef.close();
  }
  submit(): void {
    const data = this.form.getRawValue();
    this.dialogRef.close(data);
  }
}
